"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toNumber;

function toNumber(num) {
  var number = num;

  if (number === undefined) {
    return 0;
  }

  if (typeof num === 'string') {
    number = num.replace(/,/g, '');
  }

  return Number(number);
}